import { useEffect, useState } from "react";

// Public runtime config fetched from /api/config.
// While Stripe is not yet live the site owner keeps `products_available=false`,
// which flips every Add-to-Cart into the disabled "AVAILABLE SOON" state and
// hides the cart entry points. Nothing is deleted — flipping the flag back to
// true instantly restores full commerce behaviour.
let cached = null;
let inflight = null;

export function useSiteConfig() {
  const [cfg, setCfg] = useState(cached);
  useEffect(() => {
    if (cached) return;
    const API = process.env.REACT_APP_BACKEND_URL;
    inflight = inflight || fetch(`${API}/api/config`).then(r => r.json()).catch(() => ({
      commerce_enabled: true, stripe_configured: false, products_available: false,
    }));
    inflight.then((data) => { cached = data; setCfg(data); });
  }, []);
  return cfg || { commerce_enabled: true, stripe_configured: false, products_available: false };
}
